export default __webpack_public_path__ + "static/media/Savant's Gloves of the Effulgent Blade.ab983cab.jpg";